
export const INVOICE_SAVE_ADD_PAGE_ACTION = 'INVOICE_SAVE_ADD_PAGE_ACTION'
export const INVOICE_SAVE_ADD_PAGE_ACTION_SUCCESS = 'INVOICE_SAVE_ADD_PAGE_ACTION_SUCCESS'

export const INVOICE_LIST_GO_BUTTON_FILTER = 'INVOICE_LIST_GO_BUTTON_FILTER'
export const INVOICE_LIST_GO_BUTTON_FILTER_SUCCESS = 'INVOICE_LIST_GO_BUTTON_FILTER_SUCCESS'

export const EDIT_INVOICE_ACTION = 'EDIT_INVOICE_ACTION'
export const EDIT_INVOICE_ACTION_SUCCESS = 'EDIT_INVOICE_ACTION_SUCCESS'

export const UPDATE_INVOICE_ACTION = 'UPDATE_INVOICE_ACTION'
export const UPDATE_INVOICE_ACTION_SUCCESS = 'UPDATE_INVOICE_ACTION_SUCCESS'


export const DELETE_INVOICE_LIST_PAGE = 'DELETE_INVOICE_LIST_PAGE'
export const DELETE_INVOICE_LIST_PAGE_SUCCESS = 'DELETE_INVOICE_LIST_PAGE_SUCCESS'

export const GO_BUTTON_FOR_INVOICE_ADD = 'GO_BUTTON_FOR_INVOICE_ADD'
export const GO_BUTTON_FOR_INVOICE_ADD_SUCCESS = 'GO_BUTTON_FOR_INVOICE_ADD_SUCCESS'


export const INVOICE_SEND_TO_SCM_ACTION = 'INVOICE_SEND_TO_SCM_ACTION'
export const INVOICE_SEND_TO_SCM_ACTION_SUCCESS = 'INVOICE_SEND_TO_SCM_ACTION_SUCCESS'


export const MAKE_IB_INVOICE_ACTION = 'MAKE_IB_INVOICE_ACTION'
export const MAKE_IB_INVOICE_ACTION_SUCCESS = 'MAKE_IB_INVOICE_ACTION_SUCCESS'


//**************************** E-Invoice (upload ,cancel,print) ***************************************/

export const UPLOADED_E_INVOICE_ACTION = 'UPLOADED_E_INVOICE_ACTION'
export const UPLOADED_E_INVOICE_ACTION_SUCCESS = 'UPLOADED_E_INVOICE_ACTION_SUCCESS'

export const CANCLE_E_INVOICE_ACTION = 'CANCLE_E_INVOICE_ACTION'
export const CANCLE_E_INVOICE_ACTION_SUCCESS = 'CANCLE_E_INVOICE_ACTION_SUCCESS'

//**************************** E-WayBill(upload ,cancel,print) actions ***************************************/

export const UPLOADED_E_WAY_BILL_ACTION = 'UPLOADED_E_WAY_BILL_ACTION'
export const UPLOADED_E_WAY_BILL_ACTION_SUCCESS = 'UPLOADED_E_WAY_BILL_ACTION_SUCCESS'

export const CANCLE_E_WAY_BILL_ACTION = 'CANCLE_E_WAY_BILL_ACTION'
export const CANCLE_E_WAY_BILL_ACTION_SUCCESS = 'CANCLE_E_WAY_BILL_ACTION_SUCCESS'

export const UPDATE_VEHICLE_INVOICE_ACTION = 'UPDATE_VEHICLE_INVOICE_ACTION'
export const UPDATE_VEHICLE_INVOICE_SUCCESS = 'UPDATE_VEHICLE_INVOICE_SUCCESS'


export const INVOICE_BULK_DELETE_IDS_ACTION = 'INVOICE_BULK_DELETE_IDS_ACTION'
export const INVOICE_BULK_DELETE_IDS_SUCCESS = 'INVOICE_BULK_DELETE_IDS_SUCCESS'

export const UPDATE_VEHICLE_CUSTOMER_INVOICE_ACTION = 'UPDATE_VEHICLE_CUSTOMER_INVOICE_ACTION'
export const UPDATE_VEHICLE_CUSTOMER_INVOICE_ACTION_SUCCESS = 'UPDATE_VEHICLE_CUSTOMER_INVOICE_ACTION_SUCCESS'




export const INVOICE_API_ERROR_ACTION = "INVOICE_API_ERROR_ACTION"

export const LIST_BUTTON_LOADING_START = 'LIST_BUTTON_LOADING_START'
export const LIST_BUTTON_LOADING_END = 'LIST_BUTTON_LOADING_END'